// Ecosystem hub panel — real integration logos from the live Add-Ons assets.
import Logo from '@/components/Logo'
import { useT } from '@/i18n/useT'
import quickbooks from '@/assets/integrations/Quickbooks.png'
import xero from '@/assets/integrations/Xero.png'
import netsuite from '@/assets/integrations/NetSuite.png'
import zohoBooks from '@/assets/integrations/ZohoBooks.png'
import deputy from '@/assets/integrations/Deputy.png'
import sevenShifts from '@/assets/integrations/7shifts.png'
import whenIWork from '@/assets/integrations/WhenIWork.png'
import toggl from '@/assets/integrations/Toggl.png'
import namely from '@/assets/integrations/Namely.png'

type Logo = { name: string; src?: string }

const row1: Logo[] = [
  { name: 'QuickBooks', src: quickbooks },
  { name: 'Xero', src: xero },
  { name: 'NetSuite', src: netsuite },
  { name: 'Zoho Books', src: zohoBooks },
]

function LogoTile({ name, src }: Logo) {
  return (
    <div
      title={name}
      className="rounded-xl bg-white border border-slate-100 shadow-[0_4px_14px_-6px_rgb(15_23_42/0.12)] hover:shadow-[0_10px_24px_-8px_rgb(15_23_42/0.2)] hover:-translate-y-0.5 transition-all h-[72px] grid place-items-center px-4"
    >
      {src ? (
        <img
          src={src}
          alt={`${name} logo`}
          loading="lazy"
          className="max-h-8 w-auto object-contain"
        />
      ) : (
        <span className="font-display font-bold text-[13px] text-ink-soft text-center leading-tight">
          {name}
        </span>
      )}
    </div>
  )
}

export default function EcosystemPanel() {
  const t = useT()
  const row3: Logo[] = [
    { name: 'When I Work', src: whenIWork },
    { name: 'Toggl', src: toggl },
    { name: 'Namely', src: namely },
    { name: t.home.eco.yourApp },
  ]
  return (
    <div className="relative rounded-3xl bg-gradient-to-br from-brand-100 via-brand-50 to-white border border-brand-100 p-8 overflow-hidden">
      {/* soft radial glow behind the hub */}
      <div
        aria-hidden
        className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-72 h-72 rounded-full bg-brand-300/40 blur-3xl"
      />
      {/* faint spokes from hub */}
      <svg
        aria-hidden
        className="absolute inset-0 w-full h-full text-brand-300/50"
        preserveAspectRatio="none"
        viewBox="0 0 100 100"
      >
        {[
          'M50 50 L12 14', 'M50 50 L37 12', 'M50 50 L63 12', 'M50 50 L88 14',
          'M50 50 L10 50', 'M50 50 L90 50',
          'M50 50 L12 86', 'M50 50 L37 88', 'M50 50 L63 88', 'M50 50 L88 86',
        ].map((d) => (
          <path key={d} d={d} stroke="currentColor" strokeWidth="0.35" strokeDasharray="2 2" fill="none" vectorEffect="non-scaling-stroke" />
        ))}
      </svg>

      <div className="relative grid grid-cols-4 gap-4 items-center">
        {row1.map((l) => (
          <LogoTile key={l.name} {...l} />
        ))}

        <LogoTile name="Deputy" src={deputy} />

        {/* hub */}
        <div className="col-span-2 h-[72px] rounded-xl bg-white border-2 border-brand-500 shadow-lg shadow-brand-600/25 grid place-items-center">
          <Logo className="h-6 w-auto" />
        </div>

        <LogoTile name="7shifts" src={sevenShifts} />

        {row3.map((l) => (
          <LogoTile key={l.name} {...l} />
        ))}
      </div>

      <p className="relative text-center text-xs text-ink-mute mt-6">
        {t.home.eco.caption}
      </p>
    </div>
  )
}
